import firebase from 'firebase/app'
import '@firebase/messaging'

import commonsApi from '@/api/commons'

const state = {
  firebaseConfig: {
    apiKey: 'AIzaSyADLHLyOHG46he_9n5bIqXXYRcUu_lE2G4',
    authDomain: 'mesa-3-stg.firebaseapp.com',
    databaseURL: 'https://mesa-3-stg.firebaseio.com',
    projectId: 'mesa-3-stg',
    storageBucket: '',
    messagingSenderId: '495512141513',
    appId: '1:495512141513:web:ebe745ade66a738e9c1718'
  },
  token: '',
  initialized: false,
  onMessageNotification: {},
  notifications: [],
  messaging: {},
  unreadNotifications: 0,
  browserSupportFirebaseMessagin: firebase.messaging.isSupported()
}

const getters = {
  unreadNotifications (state) {
    return state.unreadNotifications
  }
}

const actions = {
  async actionClearUnreadNotifications ({ commit, state }) {
    if (state.unreadNotifications) {
      await commonsApi.updateItemDetail(process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH)
    }
    commit('mutateClearUnreadNotifications')
  },
  async getNotifications ({ commit }) {
    const notifications = await commonsApi.getItems({
      path: process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH,
      format: 'minimal'
    })
    commit('mutateClearNotifications')
    commit('mutateNotifications', notifications.data.items)
    const estadoContentSinLeer = notifications?.data?.aggregates?.Estado?.content.find(e => e.label === 'Sin Leer')
    if (estadoContentSinLeer && estadoContentSinLeer.count) {
      commit('mutateUnreadNotifications', estadoContentSinLeer.count)
    }
  },
  requestPermission ({
    dispatch,
    state
  }) {
    // Ask user form permission
    state.messaging.requestPermission().then(() => {
      // Get Token
      state.messaging.getToken().then((token) => {
        dispatch('persistToken', token)
      })
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err)
    })
  },
  async initializeNotifications ({
    commit,
    dispatch,
    state,
    rootState
  }) {
    if (
      process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes' &&
    !state.initialized &&
    rootState.session.isAuthenticated &&
    state.browserSupportFirebaseMessagin) {
      // Initialize Firebase
      firebase.initializeApp(state.firebaseConfig)
      state.messaging = firebase.messaging()

      commit('mutateSetInitialized')
      if ('Notification' in window) {
        // El browser soporta notificaciones
        // eslint-disable-next-line
        if (Notification.permission === 'granted') {
          state.messaging.getToken().then((token) => {
            dispatch('persistToken', token)
          })
        }

        // Notificaciones en primer plano
        state.messaging.onMessage((payload) => {
          // Solo los usuarios autenticados reciben push
          if (rootState.session.isAuthenticated) {
            commit('mutateOnMessageNotification', payload)
          }
        })

        // Callback fired if Instance ID token is updated.
        state.messaging.onTokenRefresh(() => {
          // XXX: Se deberia invalidar el token previo
          // Y luego obtener el nuevo token y persistirlo
          state.messaging.getToken().then((refreshedToken) => {
            dispatch('persistToken', refreshedToken)
          }).catch((err) => {
            console.log('Unable to refresh token', err)
          })
        })
      }
    } else if (process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes' &&
    state.initialized &&
    rootState.session.isAuthenticated) {
      console.log('intentando obtener el token nuevamente')
      state.messaging.getToken().then((token) => {
        dispatch('persistToken', token)
      })
    }
  },
  async persistToken ({ commit, rootState }, token) {
    if (rootState.session.isAuthenticated && token) {
      await commonsApi.updateItemDetail('notificaciones/token/nuevo/', {
        token
      })
    }
  }
}

const mutations = {
  mutateSetInitialized (state) {
    state.initialized = true
  },
  mutateClearInitialized (state) {
    state.initialized = false
  },
  mutateOnMessageNotification (state, payload) {
    state.onMessageNotification = payload.notification
  },
  mutateNotifications (state, payload) {
    const notifications = payload.map(notification => {
      if (!notification?.icon) {
        notification.icon = localStorage.getItem('favicon')
      }
      return notification
    })
    state.notifications.push(...notifications)
  },
  mutateUnreadNotifications (state, payload) {
    state.unreadNotifications = payload
  },
  mutateClearUnreadNotifications (state) {
    state.unreadNotifications = 0
  },
  mutateClearNotifications (state) {
    state.notifications.length = 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
